import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Bot, Cpu, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SHOPIFY_INSTALL_URL } from './Navbar';

const CTA_IMAGE = '/assets/cta-bg.jpg';

const CTASection = () => {
  return (
    <section className="py-16 sm:py-24 md:py-32 relative overflow-hidden" data-testid="cta-section">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={CTA_IMAGE}
          alt="Team celebrating success"
          className="w-full h-full object-cover"
          data-testid="cta-bg-image"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-teal-900/90 to-emerald-900/85" />
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,white_1px,transparent_1px)] bg-[size:40px_40px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="inline-flex items-center gap-2 bg-white/20 border border-white/30 rounded-full px-3 sm:px-4 py-2 mb-4 sm:mb-6 backdrop-blur-sm">
            <Cpu className="w-4 h-4 text-white" />
            <span className="text-xs sm:text-sm font-bold text-white">Deploy AI Today</span>
          </div>
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 sm:mb-6 leading-tight px-4">
            Stop Losing Sales. Start Using AI.
          </h2>
          
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed px-4">
            Optimize your e-commerce store with Arismate AI to automate sales and scale revenue 24/7.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <a href={SHOPIFY_INSTALL_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-white text-teal-700 hover:bg-teal-50 group font-bold text-sm sm:text-base px-6 sm:px-8 py-5 sm:py-6 shadow-xl"
                data-testid="cta-install-btn"
              >
                <Zap className="w-5 h-5 mr-2" />
                Install on Shopify
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <Link to="/contact" className="w-full sm:w-auto">
              <Button 
                size="lg" 
                variant="outline" 
                className="w-full sm:w-auto border-2 border-white/40 text-white hover:bg-white/10 font-bold text-sm sm:text-base px-6 sm:px-8 py-5 sm:py-6"
                data-testid="cta-contact-btn"
              >
                <Bot className="w-5 h-5 mr-2" />
                Contact Us
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
